module.exports = __webpack_public_path__ + "static/media/galerija_2017 (37).79fc69b7.jpg";